import type { ChangelogEntry } from "../types";

/** Alle ansatte kan opprette kunder, ikke bare admin og prosjektledere. */
export const ALLE_KAN_OPPRETTE_KUNDE_2026_10: ChangelogEntry = {
  id: "2026-10-25-alle-kan-opprette-kunde",
  date: "2026-10-25",
  title: "Alle ansatte kan opprette kunder",
  summary: "«Ny kunde» virker nå for alle ansatte, også de som ikke er prosjektleder eller rådgiver på noe prosjekt ennå.",
  sections: [
    {
      heading: "Kunder",
      minRole: "user",
      items: [
        {
          title: "Opprett kunde uten å være prosjektleder",
          kind: "rettet",
          body: "Før ble en ny kunde avvist hvis du ikke var administrator eller prosjektleder eller rådgiver på minst ett prosjekt. Det traff blant annet nye prosjektledere som skulle lage sitt første prosjekt med en ny kunde. Nå kan alle ansatte opprette kunder, fra kundelisten, nytt prosjekt og tilbud. Å endre kundeinfo etterpå krever fortsatt det samme som før.",
        },
      ],
    },
  ],
};
